import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Analytics from 'arbitrip-common/client/analytics';
import { useTranslation } from 'react-i18next';
import { RTL } from 'arbitrip-common/translation/const';
import CloseOutlined from '@mui/icons-material/CloseOutlined';

const SettlePaymentTitle = ({ title, subtitle, content, booking, showBackButton = false, onBack, onClose }) => {
	const { t, i18n } = useTranslation();

	const handleCloseClick = () => {
		Analytics.actions.interactions.closedPointsModal(booking?.id);
		if (_.isFunction(onClose)) {
			onClose();
		}
	};

	const isRTL = i18n.dir() === RTL;

	return (
		<div className="settle-payment-title">
			<div className="settle-payment-title__start">
				{showBackButton && (
					<div className="settle-payment-title__back">
						<IconButton aria-label="close" onClick={onBack} className="close-button" size="large" disableRipple>
							<ArrowBackIcon style={{ transform: isRTL ? 'rotate(180deg)' : 'none' }} />
						</IconButton>
					</div>
				)}
				<div className="settle-payment-title__details">
					<div className="title-text">{title}</div>
					<div className="subtitle-text">{subtitle}</div>
				</div>
			</div>
			{content}
			<IconButton className="close-button" onClick={handleCloseClick} aria-label="Close" disableRipple>
				<CloseOutlined />
			</IconButton>
		</div>
	);
};

SettlePaymentTitle.propTypes = {
	booking: PropTypes.shape({
		id: PropTypes.string,
		sort_id: PropTypes.string,
	}),
	onClose: PropTypes.func,
};

export default SettlePaymentTitle;
